import React, { useEffect } from "react";

// Context
import { useFormSelectDialog, focusPrevOption, focusNextOption } from "./index";

// styles
import { DialogStyled } from "./styles";

// components
import DialogOption from "./DialogOption";

const Dialog = () => {
    const {
        id,
        options,
        dialogWidth,
        controlHeight,
        dialogZIndex,
        dialogAlignment
    } = useFormSelectDialog();

    // side effects
    useEffect(() => {
        const onKeyDown = event => {
            switch (event.key) {
                case "ArrowUp":
                    focusPrevOption(options, id);
                    break;
                case "ArrowDown":
                    focusNextOption(options, id);
                    break;
                default:
                    return;
            }
        };

        window.addEventListener("keydown", onKeyDown);

        return () => {
            window.removeEventListener("keydown", onKeyDown);
        };
    }, []);

    return (
        <DialogStyled
            {...{ dialogWidth, controlHeight, dialogZIndex, dialogAlignment }}
        >
            {options.map(option => {
                return <DialogOption key={option.id} option={option} />;
            })}
        </DialogStyled>
    );
};

export default Dialog;
